import { throttle } from 'lodash';
import { resizeWindowPos } from './popUpView';

export function windowAction() {
  window.addEventListener('DOMContentLoaded', () => {
    headerTriggerObserve();
  });

  window.addEventListener(
    'scroll',
    _.throttle(
      (e) => {
        headerTriggerObserve();
        scrollBtnView();
        return false;
      },
      100,
      { trailing: true, leading: true }
    )
  );

  window.addEventListener(
    'resize',
    _.throttle(
      (e) => {
        headerTriggerObserve();
        resizeWindowPos();
        return false;
      },
      100,
      { trailing: true, leading: true }
    )
  );

  window.addEventListener('load', () => {
    headerTriggerObserve();
    scrollBtnView();
  });

  function headerTriggerObserve() {
    if (document.querySelector('.js-headerTrigger')) {
      const headerTriggerEle = document.querySelector('.js-headerTrigger');
      const headerInfoEle = document.querySelector('.js-headerInfo');
      const IS_ANIMATED = 'is-animated';
      const IS_HIDE = 'is-hide';

      if (headerTriggerEle.classList.contains(IS_ANIMATED)) {
        headerInfoEle.firstElementChild.classList.add(IS_HIDE);
        headerInfoEle.lastElementChild.classList.remove(IS_HIDE);
      } else {
        headerInfoEle.firstElementChild.classList.remove(IS_HIDE);
        headerInfoEle.lastElementChild.classList.add(IS_HIDE);
      }
    }
  }

  function scrollBtnView() {
    const pageTopBtn = document.querySelector('.js-pageTopBtn');
    const scroll = window.scrollY;

    // スクロール量がkvの高さを超えたらページトップボタンを表示
    if (scroll > 200) {
      pageTopBtn.classList.add('is-view');
    } else {
      pageTopBtn.classList.remove('is-view');
    }
  }
}
